import { useState, useEffect } from "react";
import "./LifeSkillCourses.css";
import  leftimg from "../assets/Lifeleftimg.png"
import rightimg from "../assets/Stemrightimg.png"

import Testimonials from "../MyComponents/Testimonials"
import FAQ from "../MyComponents/FooterPages/newfaq.js"
import { Link } from "react-router-dom"
import Navbar from "../MyComponents/Navbars/GuestNav"
import Footer from "../MyComponents/Footer"
import heroContent from './StemCourses/HeroContent.js';

import PopularCourses from "../MyComponents/PopularCourses";


// import Testimonials from "../components/Testimonials"
 import Hero2 from "../MyComponents/Hero2.js"
 import CertificateVerification from "../MyComponents/CertificateVerification";
 import leftimgs from "../assets/boy-with-laptop.png"
 import rightimgs from "../assets/kids-on-book.png"

const LifeSkillCourses = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Ensures Comic Sans is loaded (will be handled by @import in CSS)
  }, []);
  const Stemcoursespage = heroContent.StemSection;
  if (!Stemcoursespage) {
    return <div>Error: Hero content not found.</div>;
  }
  return (
     <>
     <Navbar/>
     <Hero2
              titlePart1={Stemcoursespage.titlePart1}
              titlePart2={Stemcoursespage.titlePart2}
              description={Stemcoursespage.description}
              buttonText={Stemcoursespage.buttonText}
              leftImage={leftimgs}
              rightImage={rightimgs}
     />
     
    <div className="index-root">
      
      {/* Left side decorative image */}
      {/* <div className="left-img">
        <img
          src={leftimg}
          alt="Decorative calculator and supplies"
          style={{ width: "200px", objectFit: "contain" }}
          onLoad={() => setIsImageLoaded(true)}
        />
      </div> */}

     
      {/* Main content container */}
      <div className="index-container">
        {/* Heading */}
        <h1 className="index-heading">
          Advantages of Taking STEM Courses from{" "}
          <span className="highlight">Polymath-Kids</span>
        </h1>

        {/* Advantages grid container */}
        <div className="advantages-bg">
          <div className="advantages-grid">
            {/* Advantage 1 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Hands-on">🧪</span>
              </div>
              <div>
                <span className="advantage-label hands-on">Hands-on Learning</span>
                <span className="advantage-desc"> - Kids build real projects that spark creativity.</span>
              </div>
            </div>
            {/* Advantage 2 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="STEM.org">🔍</span>
              </div>
              <div>
                <span className="advantage-label stem">STEM.org Certified</span>
                <span className="advantage-desc"> - Trusted, global-standard curriculum.</span>
              </div>
            </div>
            {/* Advantage 3 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Teacher">👨‍🏫</span>
              </div>
              <div>
                <span className="advantage-label teacher">Expert Teachers</span>
                <span className="advantage-desc"> - Learn from experienced mentors.</span>
              </div>
            </div>
            {/* Advantage 4 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Fun">👦</span>
              </div>
              <div>
                <span className="advantage-label fun">Fun & Age-Appropriate</span>
                <span className="advantage-desc"> - Courses tailored to every age group.</span>
              </div>
            </div>
            {/* Advantage 5 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Flexible">🏠</span>
              </div>
              <div>
                <span className="advantage-label flexible">Flexible & Online</span>
                <span className="advantage-desc"> - Learn anytime, from anywhere.</span>
              </div>
            </div>
            {/* Advantage 6 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Skills">💡</span>
              </div>
              <div>
                <span className="advantage-label skills">21st-Century Skills</span>
                <span className="advantage-desc"> - Boost leadership, teamwork & problem-solving.</span>
              </div>
            </div>
            {/* Advantage 7 */}
            <div className="advantage">
              <div className="advantage-icon">
                <span role="img" aria-label="Community">🌎</span>
              </div>
              <div>
                <span className="advantage-label community">Global Community</span>
                <span className="advantage-desc"> - Join a diverse group of young learners worldwide.</span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button with character illustration */}
        <div className="cta-row">
          <div className="cta-char">
            <div
              className="cta-char-inner"
              // style={{
              //   backgroundImage:
              //     'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'50\' cy=\'40\' r=\'20\' fill=\'%233F51B5\'/%3E%3Crect x=\'35\' y=\'65\' width=\'30\' height=\'35\' fill=\'%233F51B5\'/%3E%3C/svg%3E")',
              // }}
            ></div>
          </div>
          <button className="cta-btn">
            Book a free demo lesson
          </button>
        </div>
      </div>
       <PopularCourses/>
       <CertificateVerification/> 
       
       
    </div>
    <Testimonials/>
    <FAQ/>
    <section className="gallery-section">
              <div className="container">
                <div className="gallery-header">
                  <h2 className="gallery-title">
                    <span className="gallery-of">Gallery of </span>
                    <span className="learning-growth">Learning & Growth</span>
                  </h2>
                  <div className="sun-icon">
                    <img src={require("../assets/sun.png")} alt="Sun" />
                  </div>
                </div>
    
                <div className="gallery-grid">
                  {[...Array(8)].map((_, i) => (
                    <div className="gallery-item" key={i}>
                      <img
                        src={
                          require(`../assets/kid${i + 7}.png`) || "/placeholder.svg"
                        }
                        alt="Learning child"
                      />
                    </div>
                  ))}
                </div>
    
                <div className="calculator-icon">
                  <img src={require("../assets/calculator.png")} alt="Calculator" />
                </div>
    
                <div className="gallery-button">
                  <Link to="/gallery">
                    <img
                      src={require("../assets/viewgallery.png")}
                      alt="View Gallery"
                    />
                  </Link>
                </div>
              </div>
            </section>
            <Footer/>
    </>
  );
};

export default LifeSkillCourses;